<template>
      <div id="filterPanel" class="ms-Panel ms-Panel--left">
        <span class="ms-Panel-closeButton ms-PanelAction-close">
            <i class="ms-Panel-closeIcon ms-Icon ms-Icon--Cancel"></i>
        </span>
        <div class="ms-Panel-contentInner">
            <div id="filterHeader">
                <button id="toggleAllFilters" class="ms-Button ms-Button--small">
                        <span class="ms-Button-label">Toggle All</span> 
                      </button>
            <p class="ms-Panel-headerText">Filter Lets</p>
            </div>
            

            <div class="ms-Panel-content" id="divisionFilter">
                <div class="ms-CheckBox"><input checked type="checkbox" class="ms-CheckBox-input" id="Central"><label
                        role="checkbox" class="ms-CheckBox-field" aria-checked="true" for="Central"><span
                            class="ms-Label">Central</span></label></div>
                <div class="ms-CheckBox"><input checked type="checkbox" class="ms-CheckBox-input" id="Roadside"><label
                        role="checkbox" class="ms-CheckBox-field" aria-checked="true" for="Roadside"><span
                            class="ms-Label">Roadside</span></label></div>
                <div class="ms-CheckBox"><input checked type="checkbox" class="ms-CheckBox-input"
                        id="Design Build"><label role="checkbox" class="ms-CheckBox-field" aria-checked="true"
                        for="Design Build"><span class="ms-Label">Design Build</span></label></div>
                <hr />
                <div class="ms-CheckBox"><input checked type="checkbox" class="ms-CheckBox-input" id="Division 1"><label
                        role="checkbox" class="ms-CheckBox-field" aria-checked="true" for="Division 1"><span
                            class="ms-Label">Division 1</span></label>
                    <em>Bertie, Camden, Chowan, Currituck, Dare, Gates, Hertford, Hyde, Martin, Northampton, Pasquotank,
                        Perquimans, Tyrrell, Washington</em>
                </div>
                <div class="ms-CheckBox"><input checked type="checkbox" class="ms-CheckBox-input" id="Division 2"><label
                        role="checkbox" class="ms-CheckBox-field" aria-checked="true" for="Division 2"><span
                            class="ms-Label">Division 2</span></label><em>Beaufort, Carteret, Craven, Greene, Jones,
                        Lenoir, Pamlico, Pitt</em></div>
                <div class="ms-CheckBox"><input checked type="checkbox" class="ms-CheckBox-input" id="Division 3"><label
                        role="checkbox" class="ms-CheckBox-field" aria-checked="true" for="Division 3"><span
                            class="ms-Label">Division 3</span></label><em>Brunswick, Duplin, New Hanover, Onslow,
                        Pender, Sampson</em></div>
                <div class="ms-CheckBox"><input checked type="checkbox" class="ms-CheckBox-input" id="Division 4"><label
                        role="checkbox" class="ms-CheckBox-field" aria-checked="true" for="Division 4"><span
                            class="ms-Label">Division 4</span></label><em>Edgecombe, Halifax, Johnston, Nash, Wayne,
                        Wilson</em></div>
                <div class="ms-CheckBox"><input checked type="checkbox" class="ms-CheckBox-input" id="Division 5"><label
                        role="checkbox" class="ms-CheckBox-field" aria-checked="true" for="Division 5"><span
                            class="ms-Label">Division 5</span></label><em>Durham, Franklin, Granville, Person, Vance,
                        Wake, Warren</em></div>
                <div class="ms-CheckBox"><input checked type="checkbox" class="ms-CheckBox-input" id="Division 6"><label
                        role="checkbox" class="ms-CheckBox-field" aria-checked="true" for="Division 6"><span
                            class="ms-Label">Division 6</span></label><em>Bladen, Columbus, Cumberland, Harnett,
                        Robeson</em></div>
                <div class="ms-CheckBox"><input checked type="checkbox" class="ms-CheckBox-input" id="Division 7"><label
                        role="checkbox" class="ms-CheckBox-field" aria-checked="true" for="Division 7"><span
                            class="ms-Label">Division 7</span></label><em>Alamance, Caswell, Guilford, Orange,
                        Rockingham</em></div>
                <div class="ms-CheckBox"><input checked type="checkbox" class="ms-CheckBox-input" id="Division 8"><label
                        role="checkbox" class="ms-CheckBox-field" aria-checked="true" for="Division 8"><span
                            class="ms-Label">Division 8</span></label><em>Chatham, Hoke, Lee, Montgomery, Moore,
                        Randolph, Richmond, Scotland</em></div>
                <div class="ms-CheckBox"><input checked type="checkbox" class="ms-CheckBox-input" id="Division 9"><label
                        role="checkbox" class="ms-CheckBox-field" aria-checked="true" for="Division 9"><span
                            class="ms-Label">Division 9</span></label><em>Davidson, Davie, Forsyth, Rowan, Stokes</em>
                </div>
                <div class="ms-CheckBox"><input checked type="checkbox" class="ms-CheckBox-input"
                        id="Division 10"><label role="checkbox" class="ms-CheckBox-field" aria-checked="true"
                        for="Division 10"><span class="ms-Label">Division 10</span></label><em>Anson, Cabarrus,
                        Mecklenburg, Stanly, Union</em></div>
                <div class="ms-CheckBox"><input checked type="checkbox" class="ms-CheckBox-input"
                        id="Division 11"><label role="checkbox" class="ms-CheckBox-field" aria-checked="true"
                        for="Division 11"><span class="ms-Label">Division 11</span></label><em>Alleghany, Ashe, Avery,
                        Caldwell, Surry, Watauga, Wilkes, Yadkin</em></div>
                <div class="ms-CheckBox"><input checked type="checkbox" class="ms-CheckBox-input"
                        id="Division 12"><label role="checkbox" class="ms-CheckBox-field" aria-checked="true"
                        for="Division 12"><span class="ms-Label">Division 12</span></label><em>Alexander, Catawba,
                        Cleveland, Gaston, Iredell, Lincoln</em></div>
                <div class="ms-CheckBox"><input checked type="checkbox" class="ms-CheckBox-input"
                        id="Division 13"><label role="checkbox" class="ms-CheckBox-field" aria-checked="true"
                        for="Division 13"><span class="ms-Label">Division 13</span></label><em>Buncombe, Burke, Madison,
                        McDowell, Mitchell, Rutherford, Yancey</em></div>
                <div class="ms-CheckBox"><input checked type="checkbox" class="ms-CheckBox-input"
                        id="Division 14"><label role="checkbox" class="ms-CheckBox-field" aria-checked="true"
                        for="Division 14"><span class="ms-Label">Division 14</span></label><em>Cherokee, Clay, Graham,
                        Haywood, Henderson, Jackson, Macon, Polk, Swain, Transylvania</em></div>
                <br /><br />
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: "PanelDivisionFilter",
  props: {
    // msg: String
  }
};
</script>